<template>
  <b-skeleton-wrapper :loading="rlsGroupFetching">
    <template v-slot:loading>
      <b-skeleton
        v-for="(item, key) in items"
        :key="`company-rls-group-list-skeleton-item-${key}`"
        :width="`${item}%`"
        height="20px"
        animation="fade"
      ></b-skeleton>
    </template>

    <slot />
  </b-skeleton-wrapper>
</template>

<script>
import { defineComponent, computed, inject } from '@vue/composition-api'

export default defineComponent({
  name: 'CompanyRLSGroupListSkeleton',
  setup() {
    const { rlsGroupFetching } = inject('company-rls-group')

    const items = computed(() =>
      Array.from({ length: 5 }, () => {
        const value = Math.floor(Math.random() * 50)

        return 15 > value ? 15 : value
      })
    )

    return {
      rlsGroupFetching,

      items
    }
  }
})
</script>
